import http from "@/apps/rever-academy/http";
class CourseService {
    getOptionsByName(name: string | null) {
        return http.get(`/api/course/search-option?name=${name}`);
    }

}
export default new CourseService();

